export const MAX_DISPLAY_PICTURE_SIZE_TO_LIMIT = 3;
export const MAX_DOCUMENT_SIZE_TO_UPLOAD = 5;

export const ICON_COMPONENT: {
  [key: string]: string;
} = {
  medical: 'ph-stethoscope',
  medical_2: 'ph-stethoscope',
  dental: 'ph-tooth',
  vision: 'ph-eyeglasses',
  rx: 'ph-prescription',
  ichra: 'ph-piggy-bank',
  hcra: 'ph-piggy-bank',
  dcra: 'ph-piggy-bank',
  hsa: 'ph-piggy-bank',
  premium_fsa: 'ph-piggy-bank',
  '401k': 'ph-piggy-bank',
  '401k_catch_up': 'ph-piggy-bank',
  '401k_roth': 'ph-piggy-bank',
  '401k_roth_catch_up': 'ph-piggy-bank',
  hra: 'ph-piggy-bank',
  parking: 'ph-piggy-bank',
  transit: 'ph-piggy-bank',
  transit_2: 'ph-piggy-bank',
  bltd: 'ph-wheelchair',
  bstd: 'ph-wheelchair',
  basic_subscriber_life: 'ph-umbrella',
  basic_spouse_life: 'ph-umbrella',
  basic_dependent_life: 'ph-umbrella',
  basic_add: 'ph-heartbeat',
  eap: 'ph-question',
  work_accident: 'ph-first-aid',
  ltd: 'ph-wheelchair',
  std: 'ph-wheelchair',
  subscriber_life: 'ph-umbrella',
  spouse_life: 'ph-umbrella',
  dependent_life: 'ph-umbrella',
  add: 'ph-heartbeat',
  add_dep_only: 'ph-heartbeat',
  add_spouse_only: 'ph-heartbeat',
  life_employee_group_whole_life: 'ph-umbrella',
  life_spouse_group_whole_life: 'ph-umbrella',
  life_dependent_group_whole_life: 'ph-umbrella',
  life_employee_group_universal_life: 'ph-umbrella',
  life_spouse_group_universal_life: 'ph-umbrella',
  life_dependent_group_universal_life: 'ph-umbrella',
  group_hospital_indemnity: 'ph-first-aid',
  flex_credit: 'ph-currency-circle-dollar',
  cancer: 'ph-pill',
  miscellaneous: 'ph-first-aid',
  legal: 'ph-gavel',
  long_term_care: 'ph-hand-heart',
  specified_health: 'ph-shield-plus',
  hosp_intensive: 'ph-bed',
  critical_illness: 'ph-shield-check',
  critical_illness_2: 'ph-shield-check',
  critical_illness_3: 'ph-shield-check',
  admin_fee: 'ph-currency-dollar',
  pto_purchase: 'ph-calendar-plus',
  pto_cash_out: 'ph-coins',
  total_comensation_statement: 'ph-file-text',
  loan_contribution: 'ph-hand-coins',
  personal_loan: 'ph-bank',
  id_theft: 'ph-hand',
  Agreement_1: 'ph-handshake',
  Agreement_2: 'ph-handshake',
  Agreement_3: 'ph-handshake',
  Agreement_4: 'ph-handshake',
  Agreement_5: 'ph-handshake',
  Agreement_6: 'ph-handshake',
  Agreement_7: 'ph-handshake',
  Agreement_8: 'ph-handshake',
  Agreement_9: 'ph-handshake',
  Agreement_10: 'ph-handshake',
};

export const benefitCategoryLookupCodes = [
  'category_1',
  'category_2',
  'category_3',
  'category_4',
];
